import { motion } from "framer-motion";
import { Star, ExternalLink, PenLine } from "lucide-react";

const MAPS_REVIEWS_URL =
  "https://www.google.com/maps/place/SC+Speed+Shop+Power+SRL/@45.7467316,21.2098728,17z/data=!4m8!3m7!1s0x47455d7044f5719f:0xb6b8d9540939e51!8m2!3d45.7467316!4d21.2098728!9m1!1b1!16s/g/11gg9dt2p1";

const REVIEWS = [
  {
    name: "Andrei Drăgoi",
    stars: 5,
    when: "Recent",
    text: "Nouă",
    tag: "Recenzie nouă",
  },
  {
    name: "Stefan Tat",
    stars: 4,
    when: "acum 5 ani",
    text: "O locație ușor de găsit, în apropierea Gării de Nord și Bega. Un magazin deservit cu personal profesionist, amabil și care te ajută la rezolvarea doleanțelor.",
    tag: null,
  },
];

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-700"}`} />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="recenzii" data-testid="reviews-section" className="relative py-20 lg:py-28 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-4"
        >
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-[#FF2A3B]">Recenzii Google</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight leading-tight">
            Ce spun <span className="text-[#0055FF]">clienții</span>
          </h2>

          <div data-testid="reviews-score-card" className="mt-8 border border-white/10 bg-[#131927] p-8">
            <div className="flex items-end gap-3">
              <span data-testid="reviews-average" className="font-display text-7xl font-black leading-none">3,5</span>
              <span className="mb-2 text-slate-500 text-sm">/ 5</span>
            </div>
            <div className="mt-3"><Stars n={3} /></div>
            <p data-testid="reviews-count" className="mt-3 text-xs text-slate-500">
              14 recenzii pe Google · Recenziile nu sunt confirmate
            </p>
            <div className="mt-6 grid gap-3">
              <a
                data-testid="leave-review-cta"
                href="https://search.google.com/local/writereview?placeid=ChIJn3H1RHBdRUcRUZ6TQJWNaws"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#FF2A3B] hover:bg-[#0055FF] py-3.5 text-sm font-semibold transition-colors"
              >
                <PenLine className="h-4 w-4" />
                Lasă o recenzie pe Google
              </a>
              <a
                data-testid="view-google-reviews-cta"
                href={MAPS_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 border border-white/20 hover:border-[#0055FF] py-3.5 text-sm font-semibold transition-colors"
              >
                <ExternalLink className="h-4 w-4 text-[#0055FF]" />
                Vezi toate recenziile pe Google
              </a>
            </div>
          </div>

          <div className="mt-6 relative overflow-hidden border border-white/10 group">
            <img
              data-testid="reviews-shop-photo"
              src="/images/img1.jpg"
              alt="Kit curea de distribuție ContiTech Continental — piese din magazin"
              loading="lazy"
              className="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute bottom-3 left-3 bg-[#07122B]/85 px-3 py-1.5 text-[10px] font-mono uppercase tracking-[0.22em] text-white">
              Din magazin · Kit distribuție ContiTech
            </span>
          </div>
        </motion.div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4 content-start">
          {REVIEWS.map((r, i) => (
            <motion.article
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="border border-white/10 bg-[#131927] p-6 flex flex-col"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className={`grid place-items-center h-10 w-10 font-display font-bold text-sm ${r.stars >= 4 ? "bg-[#0055FF]/20 text-[#6b96ff]" : "bg-[#FF2A3B]/15 text-[#ff7b87]"}`}>
                    {r.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                  </span>
                  <div>
                    <p className="text-sm font-semibold">{r.name}</p>
                    <p className="text-[11px] text-slate-500">{r.when} · Google</p>
                  </div>
                </div>
                {r.tag && (
                  <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-emerald-400 border border-emerald-400/30 px-2 py-1">
                    {r.tag}
                  </span>
                )}
              </div>
              <div className="mt-4"><Stars n={r.stars} /></div>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed flex-1">{r.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
